(async () => {
  const el = document.getElementById('socials-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/socials.vue'),
    },
  ]

  await clientRender({ components })
})()
